import { useState, useEffect } from 'react';

export const THEMES = [
  { key: 'light',  label: 'Light',  color: '#ffffff', border: '#e5e7eb' },
  { key: 'dark',   label: 'Dark',   color: '#18181B', border: '#3f3f46' },
  { key: 'ocean',  label: 'Ocean',  color: '#0f172a', border: '#38bdf8' },
  { key: 'forest', label: 'Forest', color: '#0a1a0f', border: '#22c55e' },
  { key: 'rose',   label: 'Rose',   color: '#fff1f2', border: '#f43f5e' },
  { key: 'purple', label: 'Purple', color: '#0d0a1a', border: '#a855f7' },
];

const useTheme = () => {
  const saved = localStorage.getItem('theme');
  const system = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const [theme, setTheme] = useState(saved || system);

  useEffect(() => {
    const root = window.document.documentElement;
    // Remove all theme classes/attributes
    root.removeAttribute('data-theme');
    root.classList.remove('dark');

    root.setAttribute('data-theme', theme);
    // Keep Tailwind dark class in sync for dark-mode utilities
    if (theme === 'dark' || theme === 'ocean' || theme === 'forest' || theme === 'purple') {
      root.classList.add('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  return [theme, setTheme];
};

export default useTheme;
